import { render, staticRenderFns } from "./advBanner.vue?vue&type=template&id=ec8fc1c4"
import script from "./advBanner.vue?vue&type=script&lang=js"
export * from "./advBanner.vue?vue&type=script&lang=js"
import style0 from "./advBanner.vue?vue&type=style&index=0&id=ec8fc1c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports